import Link from "next/link";

/** Height of the sticky bar so we scroll sections to sit just below it */
const STICKY_OFFSET_PX = 56;

/**
 * Reusable scrollable secondary header. Normal in-flow block; when it reaches
 * the top of the viewport on scroll, it sticks there (position: sticky; top: 0).
 */
const navItemClasses =
  "shrink-0 py-2 px-3 text-white no-underline text-[0.9375rem] font-medium whitespace-nowrap border-b-2 border-transparent bg-transparent cursor-pointer font-inherit rounded-none transition-colors duration-200 hover:bg-white/10 inline-flex items-center";

const navItemActiveClasses = "!border-b-2 !border-white";

const baseNavClasses =
  "flex items-center gap-0 overflow-x-auto overflow-y-hidden py-3 pl-[10px] pr-0 sm:pl-[8%] md:pl-[8%] lg:pl-[8%] bg-[#2d3748] text-white w-full [&::-webkit-scrollbar]:h-1 [&::-webkit-scrollbar-thumb]:bg-white/30 [&::-webkit-scrollbar-thumb]:rounded";

export default function SecondaryHeader({
  items = [],
  activeSectionId,
  onActiveSectionChange,
  scrollOffsetTop = STICKY_OFFSET_PX,
}) {
  const handleSectionClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (!el) {
      onActiveSectionChange?.(sectionId);
      return;
    }
    const top =
      el.getBoundingClientRect().top + (typeof window !== "undefined" ? window.scrollY : 0) - scrollOffsetTop;
    if (typeof window !== "undefined") {
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }
    onActiveSectionChange?.(sectionId);
  };

  return (
    <>
      <nav
        role="navigation"
        aria-label="Page sections"
        className={`sticky top-0 left-0 right-0 z-[130] block w-full ${baseNavClasses}`}
      >
        {items.map((item, index) => {
        const isActive = activeSectionId && item.sectionId === activeSectionId;
        const itemClassName = `${navItemClasses} ${isActive ? navItemActiveClasses : ""}`;
        if (item.onClick) {
          return (
            <button
              key={index}
              type="button"
              className={itemClassName}
              onClick={(e) => {
                item.onClick(e);
                if (onActiveSectionChange && item.sectionId) {
                  onActiveSectionChange(item.sectionId);
                }
              }}
            >
              {item.label}
            </button>
          );
        }
        if (item.href) {
          const isExternal = item.href.startsWith("http");
          return (
            <Link
              key={index}
              href={item.href}
              className={itemClassName}
              {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              {item.label}
            </Link>
          );
        }
        if (item.sectionId) {
          return (
            <button
              key={index}
              type="button"
              className={itemClassName}
              onClick={() => handleSectionClick(item.sectionId)}
            >
              {item.label}
            </button>
          );
        }
        return null;
      })}
      </nav>
    </>
  );
}
